export class AzureSponsorshipConstants {
  public static PlaceholdersAndTitles = {
    BudgetProgramName: 'Budget Program Name',
    PartnerOneId: 'Partner One ID',
    PartnerOneName: 'Partner One Name',
    InvestmentAmount: 'Investment Amount (USD)',
    Area: 'Area',
    LicensingMechanism: 'Licensing Mechanism for Recipient',
    UseCase: 'Use Case',
    WorkType: 'Work Type',
    CustomerPartnerLocation: 'Customer/Partner Location',
    SaaS: 'SaaS',
    PartnerSolutionName: 'Partner Solution Name',
    CoSellReferralID: 'Co-Sell Referral ID',
    MarketplaceTransaction: 'Marketplace Transaction',
    IsRecipientGovernmentCustomer: 'Is the recipient a government customer?',
    AccountOwnerID: 'Partner/Customer Azure Account ID',
    LegacyAccountOwnerID: 'Account Owner ID',
    EAAgreementOwnerEmail: 'EA Agreement Owner Email Address',
    EAAdminEmailAddress: 'EA Administrator Email Address',
    EAEnrollmentNumber: 'EA Enrollment Number',
    MCACompanyEmail: 'MCA Company Email',
    MCABillingProfile: 'MCA Billing Profile',
    BillingAccountID: 'Billing Account ID',
    SponsorshipStartDate: 'Sponsorship Start Date',
    SponsorshipEndDate: 'Sponsorship End Date',
    SponsorshipcaseID: 'Case ID',
    CustomerEmailsToCC: 'Customer Emails to cc',
    EmailsToCC: 'Microsoft CC list',
    ApproverName: 'Approver Name',
    State: 'State',
    SubState: 'Sub State',
    Attachments: 'Attachments',
  };

  public static AzureISVtabPath = '&tab=AzureISV';

  public static BudgetPrograms = {
    FY27AzureSponsorshipForISV: 'FY27 Azure Sponsorship for ISV',
  };

  public static UATFields = {
    BudgetProgramName: 'Custom.Budget_Program_Name',
    PartnerOneId: 'Custom.Partner_One_ID',
    PartnerOneName: 'Custom.Partner_One_Name',
    InvestmentAmount: 'Custom.Investment_Amount',
    Area: 'Custom.Area',
    LicensingMechanism: 'Custom.Licensing_Mechanism_for_Recipient',
    UseCase: 'Custom.Use_Case',
    WorkType: 'Custom.WorkType',
    CustomerPartnerLocation: 'Custom.CustomerPartnerLocation',
    SaaS: 'Custom.SaaS',
    PartnerSolutionName: 'Custom.Partner_Solution_Name',
    CoSellReferralID: 'Custom.CoSellReferralID',
    MarketplaceTransaction: 'Custom.Marketplace_Transaction',
    IsRecipientGovernmentCustomer: 'Custom.Is_the_recipient_a_government_customer',
    AccountOwnerID: 'Custom.Account_Owner_ID',
    EAAccountOwnerEmail: 'Custom.EA_Account_Owner_Email',
    EAAdminEmailAddress: 'Custom.EA_Admin_Email_Address',
    MCACompanyEmail: 'Custom.MCA_Company_Email',
    MCABillingProfile: 'Custom.MCA_Billing_Profile',
    BillingAccountID: 'Custom.Billing_Account_ID',
    SponsorshipStartDate: 'Custom.Sponsorship_Start_Date',
    SponsorshipEndDate: 'Custom.Sponsorship_End_Date',
    SponsorshipcaseID: 'Custom.Sponsorship_case_ID',
    CustomerEmailsToCC: 'Custom.Customer_Emails_to_cc',
    ApproverName: 'Custom.Approver_Name',
    State: 'Custom.State',
    SubState: 'Custom.Sub_State',
  };

  public static ErrorMessages = {
    BudgetProgramNameMandatory: 'Budget Program Name is mandatory',
    PartnerOneID: 'Partner One ID is mandatory',
    PartnerOneName: 'Partner One Name is mandatory',
    InvestmentAmount: 'Investment Amount is mandatory',
    Area: 'Area is mandatory',
    LicensingMechanism: 'Licensing Mechanism for Recipient is mandatory',
    UseCase: 'Use Case is mandatory',
    WorkType: 'Work Type is mandatory',
    CustomerPartnerLocation: 'Customer/Partner Location is mandatory',
    SaaS: 'SaaS is mandatory',
    PartnerSolutionName: 'Partner Solution Name is mandatory',
    CoSellReferralID: 'Co-Sell Referral ID is mandatory',
    MarketplaceTransaction: 'Marketplace Transaction is mandatory',
    IsRecipientGovernmentCustomer: 'Is the recipient a government customer? is mandatory',
    AccountOwnerID: 'Partner/Customer Azure Account ID is mandatory',
    ValidAccountOwnerID: 'Enter a valid Partner/Customer Azure Account ID email address',
    EAAccountOwnerEmail: 'EA Agreement Owner Email Address is mandatory',
    EAAdminEmailAddress: 'EA Administrator Email Address is mandatory',
    ValidEAAccountOwnerEmail: 'Enter a valid EA Agreement Owner email address',
    ValidEAAdminEmailAddress: 'Enter a valid EA Administrator email address',
    EAEnrollmentNumber: 'EA Enrollment Number is mandatory',
    ValidEAEnrollmentNumber:
      'Enter a valid EA Enrollment Number. Only numbers are allowed, with a maximum of 10 digits.',
    MCACompanyEmail: 'MCA Company Email is mandatory',
    MCABillingProfile: 'MCA Billing Profile is mandatory',
    BillingAccountID: 'Billing Account ID is mandatory',
    SponsorshipStartDate: 'Sponsorship Start Date is mandatory',
    SponsorshipEndDate: 'Sponsorship End Date is mandatory',
    CustomerEmailsToCC: 'Customer Emails to cc is mandatory',
    EmailsToCC: 'Emails to CC is mandatory',
    ApproverName: 'Approver Name is mandatory',
    ValidInvestmentAmount: 'Please enter a valid investment amount',
    InvestmentAmountLimit: 'Investment Amount must be ≥ $5,000',

  };
}

// Generated by GitHub Copilot | Updated on: 2026-06-30 | 4 lines modified | Added FY27 Azure Sponsorship for ISV budget program constant
// Generated by GitHub Copilot | Updated on: 2026-08-24 | 6 lines modified | Updated PayGO label and EA email errors
// Generated by GitHub Copilot | Updated on: 2026-08-24 | 1 line modified | Added PayGO email error
